import {useEffect, useRef} from "react";
import "./MobileTouchAura.scss";

export default function MobileTouchAura({enabled = true}) {
  const glowRef = useRef(null);
  const trailRef = useRef(null);

  useEffect(() => {
    if (!enabled) return undefined;

    const coarse = window.matchMedia("(pointer: coarse)").matches;
    const narrow = window.matchMedia("(max-width: 768px)").matches;
    if (!coarse && !narrow) return undefined;

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return undefined;
    }

    const glow = glowRef.current;
    const trail = trailRef.current;
    if (!glow || !trail) return undefined;

    let x = 0;
    let y = 0;
    let cx = 0;
    let cy = 0;
    let tx = 0;
    let ty = 0;
    let active = false;
    let raf = 0;
    let hideTimer = null;

    const tick = () => {
      cx += (x - cx) * 0.24;
      cy += (y - cy) * 0.24;
      tx += (x - tx) * 0.12;
      ty += (y - ty) * 0.12;
      glow.style.transform = `translate3d(${cx}px, ${cy}px, 0)`;
      trail.style.transform = `translate3d(${tx}px, ${ty}px, 0)`;
      raf = requestAnimationFrame(tick);
    };

    const show = () => {
      if (hideTimer) {
        clearTimeout(hideTimer);
        hideTimer = null;
      }
      glow.classList.add("is-on");
      trail.classList.add("is-on");
      if (!active) {
        active = true;
        raf = requestAnimationFrame(tick);
      }
    };

    const hide = () => {
      hideTimer = window.setTimeout(() => {
        glow.classList.remove("is-on");
        trail.classList.remove("is-on");
        active = false;
        cancelAnimationFrame(raf);
      }, 180);
    };

    const onTouch = e => {
      const t = e.touches?.[0] || e.changedTouches?.[0];
      if (!t) return;
      x = t.clientX;
      y = t.clientY;
      show();
    };

    document.addEventListener("touchstart", onTouch, {passive: true});
    document.addEventListener("touchmove", onTouch, {passive: true});
    document.addEventListener("touchend", hide, {passive: true});
    document.addEventListener("touchcancel", hide, {passive: true});

    return () => {
      if (hideTimer) clearTimeout(hideTimer);
      cancelAnimationFrame(raf);
      document.removeEventListener("touchstart", onTouch);
      document.removeEventListener("touchmove", onTouch);
      document.removeEventListener("touchend", hide);
      document.removeEventListener("touchcancel", hide);
    };
  }, [enabled]);

  return (
    <>
      <div ref={trailRef} className="mobile-touch-trail" aria-hidden="true" />
      <div ref={glowRef} className="mobile-touch-aura" aria-hidden="true">
        <span className="mobile-touch-aura-core" />
        <span className="mobile-touch-aura-ring" />
      </div>
    </>
  );
}
